
import {map,  takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NoticeTypeService, NoticeType, TemplateTypeService } from "../../../../swaggerServices";
import { Subject ,  forkJoin } from "rxjs";
import { UpdateNoticeTypeComponent } from "../update-notice-type/update-notice-type.component";

@Component({
    selector: 'app-manage-notice-types',
    templateUrl: './manage-notice-types.component.html',
    styleUrls: ['./manage-notice-types.component.scss'],
    standalone: false
})
export class ManageNoticeTypesComponent implements OnInit, OnDestroy {

  noticeTypeList: NoticeType[] = [];
  templateTypeList = [];
  isLoading: boolean;
  groupLabelMapping = {
    'AS': 'PAYGs',
    'EX': 'Exception',
    'NOA': 'NOAs',
    'ST': 'Save to Docshare',
    'GE': 'Straight through'
  };
  private unsubscribe = new Subject<void>();

  constructor(
    private noticeTypeService: NoticeTypeService,
    private templateTypeService: TemplateTypeService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  updateNoticeType(noticeType: NoticeType) {
    this.openUpdateDialog(noticeType);
  }

  addNoticeType() {
    this.openUpdateDialog(null);
  }

  private setTemplateTypeList() {
    return this.templateTypeService.getTemplateTypes().pipe(
    map(result => {
      const templateTypes = [];
      if (result && result.length>0) {
        result.forEach(templateType => {
          templateTypes[templateType.id] = templateType.templateType;
        });
      }
      return templateTypes;
    }));
  }

  private loadData() {
    this.isLoading = true;
    forkJoin([
      this.setTemplateTypeList(),
      this.noticeTypeService.getNoticeTypes()
    ])
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(([templateTypes, noticeTypes]) => {
        this.noticeTypeList = noticeTypes;
        this.templateTypeList = templateTypes;
        this.isLoading = false;
    });
  }

  private openUpdateDialog(noticeType: NoticeType | null) {
    this.dialog.open(UpdateNoticeTypeComponent, {
      width: '640px',
      data: noticeType,
      autoFocus: 'dialog',
    }).afterClosed()
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(updated => {
      if (updated) {
        this.loadData();
      }
    });
  }

}
